import { useMutation } from "react-query";
import axiosClient from "../../../../../../../../../lib/axios";
import { useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { PesquisarTitulosAReceber } from "../../../Step01";
import { Box, Button, Grid, InputAdornment, TextField, Typography } from "@mui/material";
import LoadingApiQuery from "../../../../../../../../../components/LoadingApiQuery";
import ChipComCopyIcon from "../../../../../../../../../components/ChipComCopyIcon";
import BtnCompartilhar from "../../../../../../../../../components/BtnCompartilhar";
import LabelPrinter from "../../../../../../../../../components/LabelPrinter";
import { formatarDecimalNumber, formatarInputValorMonetárioSemPrefixo, formatarMonetárioParaNúmero, formatarValorMonetario } from "../../../../../../../../../helpers/masks";
import QRCode from "react-qr-code";
import { IRetornoEmitirPix } from "../../../../../../../../../types/mutations/financeiro/emitir-pix";
import moment from "moment";
import TemporizadorPix from "./TemporizadorPix";
import AguardandoPagamento from "./AguardandoPagamento";
import SelectLoja, { TObjValueLoja } from "../../../../../../../../../components/SelectsSimpleApiQuery/SelectLoja";
import SelectFormaRecebimento, { TObjValueFormRecebimento } from "../../../../../../../../../components/SelectsSimpleApiQuery/SelectFormaRecebimento";
import { enqueueSnackbar } from "notistack";
import BtnActionWrapper from "../../../../../../BtnActionWrapper";

export default function EmitirPix() {

    const { getValues, watch, setValue } = useFormContext();

    const totalAtt: number = getValues('total_atualizado')

    const [dadosPix, setDadosPix] = useState<IRetornoEmitirPix | null>(null)
    const [internForm, setInternForm] = useState<IInternForm>({
        formaPagamento: null,
        valor: formatarDecimalNumber(totalAtt),
    })

    //queries e mutations
    const { mutate: emitirPix, isLoading } = useMutation({
        mutationKey: 'emitir-pix',
        mutationFn: () => {
            const { selecionar_titulos } = getValues()

            return axiosClient.post(`/financeiro/contas-receber/emitir-pix`, {
                titulos: selecionar_titulos.map((i: PesquisarTitulosAReceber) => i.id),
                loja_id: lojaSelect.id,
                valor_receber: formatarMonetárioParaNúmero(String(internForm.valor)),
                forma_recebimento_id: internForm.formaPagamento?.id,
                varios_recebimentos: false,
            })
        },
        onSuccess: ({ data }) => {
            setDadosPix(data);
        }
    });

    //Funções manipuladoras
    const handleChangeLoja = (value: TObjValueLoja | null) => {
        setValue('finalizacao.loja', value)
        setInternForm({ formaPagamento: null, valor: formatarDecimalNumber(totalAtt) })
    }

    const handleChangeValues = (prop: keyof IInternForm, value: any) => {
        setInternForm(prevState => {
            return ({
                ...prevState,
                [prop]: value
            })
        })
    }

    const handleEmitirPix = () => {
        if (podeGerarPix) {
            enqueueSnackbar("Preencha todos os dados para emitir o PIX", { variant: "error" })
            return
        }
        emitirPix()
    }

    const handleBack = getValues('funcoesAux.onBack')

    const handleVoltar = () => {
        setDadosPix(null)
        setInternForm({ formaPagamento: null, valor: formatarDecimalNumber(totalAtt) })
        handleBack()
    }
    //

    //valores importantes
    const lojaSelect = watch('finalizacao.loja')

    const podeGerarPix = useMemo(() => {
        return (lojaSelect && internForm.valor && internForm.formaPagamento && internForm.valor !== '0,00') ? false : true
    }, [internForm, lojaSelect])
    //
    return (
        <>
            <Box maxWidth={500}>
                <Box pb={2}>
                    <Typography variant='h6' fontWeight="bold">PIX instantâneo</Typography>
                    <Typography variant='subtitle2'>(Um QRCode é gerado para pagamento em até 5 minutos)</Typography>
                </Box>
                {
                    isLoading &&
                    <Box width="100%"><LoadingApiQuery /></Box>
                }
                <Grid container spacing={2}>
                    {
                        !isLoading && !dadosPix &&
                        <>
                            <Grid size={{ xs: 12 }}>
                                <SelectLoja
                                    value={lojaSelect}
                                    onChange={handleChangeLoja}
                                    isDisabled={getValues('finalizacao.usuarioComLoja')}
                                />
                            </Grid>

                            {
                                Boolean(lojaSelect) &&
                                <>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <SelectFormaRecebimento
                                            value={internForm.formaPagamento}
                                            onChange={(value) => {
                                                handleChangeValues("formaPagamento", value)
                                            }}
                                            loja_id={getValues('finalizacao.loja')?.id}
                                            flg_usa_receber={true}
                                            flg_pix_configurado
                                        />

                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 6, md: 6 }}>
                                        <TextField
                                            fullWidth
                                            label='Valor recebido'
                                            type="text"
                                            value={internForm.valor}
                                            onChange={(e) => {
                                                const formattedValue = formatarInputValorMonetárioSemPrefixo(e.target.value)
                                                handleChangeValues("valor", formattedValue)
                                            }}
                                            slotProps={{
                                                input: {
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Typography color={'#000'}>R$</Typography>
                                                        </InputAdornment>
                                                    )
                                                }
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={{ xs: 12 }} display={'flex'} justifyContent={'flex-end'}>
                                        <Button
                                            variant="contained"
                                            onClick={handleEmitirPix}
                                            disabled={podeGerarPix}
                                        >
                                            Gerar PIX
                                        </Button>
                                    </Grid>
                                </>
                            }
                        </>
                    }
                    {
                        !isLoading && dadosPix &&
                        <>

                            <Grid container size={{ xs: 12 }}>
                                <Box mb={2} width={168} height={168}>
                                    <QRCode
                                        size={168}
                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                        value={dadosPix.brcode}
                                    />
                                </Box>
                                <Box ml={2} display={'flex'} flexDirection={'column'}>
                                    <LabelPrinter titulo='Valor' size="small" valor={formatarValorMonetario(dadosPix.valor)} />
                                    <Box mt={2} mb={2}>
                                        <Typography variant='subtitle2'>Gerado em</Typography>
                                        <Typography variant='body1' fontWeight={'bold'}>{moment(dadosPix.data_criacao).format('DD/MM/YYYY')}</Typography>
                                    </Box>
                                    <AguardandoPagamento codigo={dadosPix.codigo} />
                                </Box>
                            </Grid>

                            <Grid size={{ xs: 12 }}>
                                <Box mb={2}>
                                    <Typography variant='subtitle2'>Código PIX</Typography>
                                    <ChipComCopyIcon title="Código de barras" codigo={dadosPix.brcode} />
                                </Box>
                                <TemporizadorPix controleTempo={dadosPix ? true : false} expiracao={dadosPix.expiracao_pix} />
                            </Grid>

                            <Grid size={{ xs: 12 }} gap={8}>
                                <Box>
                                    <BtnCompartilhar
                                        mensagem={`Segue abaixo o código PIX no valor de ${formatarValorMonetario(dadosPix.valor)} para o pagamento do(s) título(s):\n${dadosPix.brcode}`} 
                                        tipo_publico={getValues('selecionar_titulos')[0].tipo_publico}
                                        codigo_publico={getValues('selecionar_titulos')[0].codigo_publico}
                                        />
                                </Box>
                            </Grid>
                        </>
                    }
                </Grid>
            </Box>
            <BtnActionWrapper>
                <Button onClick={handleVoltar} sx={{ pointerEvents: 'auto' }}>
                    Voltar
                </Button>
            </BtnActionWrapper>
        </>
    )
}

interface IInternForm {
    formaPagamento: TObjValueFormRecebimento | null,
    valor: string,
}
